/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './LeilaoDeVeiculosBlog.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function LeilaoDeVeiculosBlog() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="leilao-de-veiculos-blog">
        <ContainerHome24>
          <div className="is-mobi">
            <h2 className="leilao-de-veiculos-blog-titulo">Consulte nossos conteúdos</h2>
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`leilao-de-veiculos-blog-slide ${className}`}>
                    <a
                      href="blog/leilao-de-veiculos-de-financeira.html"
                      target="_blank"
                      className="leilao-de-veiculos-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-11/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-11/capa.png" />
                        <img
                          src="static/amp/blog/post-11/capa.png"
                          alt="miniatura de um carro azul sobre moedas ao lado de um martelo de leilão"
                        />
                      </picture>
                      <div className="leilao-de-veiculos-blog-card-textos">
                        <h3 className="leilao-de-veiculos-blog-slide-titulo">
                          Leilão de carros recuperados de financeira: saiba como funciona
                        </h3>
                        <p className="leilao-de-veiculos-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`leilao-de-veiculos-blog-slide ${className}`}>
                    <a
                      href="blog/comprar-carro-seminovo.html"
                      target="_blank"
                      className="leilao-de-veiculos-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-31/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-31/capa.jpg" />
                        <img
                          src="static/amp/blog/post-31/capa.jpg"
                          alt="homem olhando para um carro e pensando em comprar um carro seminovo"
                        />
                      </picture>
                      <div className="leilao-de-veiculos-blog-card-textos">
                        <h3 className="leilao-de-veiculos-blog-slide-titulo">
                          Comprar um carro seminovo é a melhor opção para o seu bolso?
                        </h3>
                        <p className="leilao-de-veiculos-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`leilao-de-veiculos-blog-slide ${className}`}>
                    <a
                      href="blog/carros-novos-ou-usados.html"
                      target="_blank"
                      className="leilao-de-veiculos-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-42/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-42/capa.png" />
                        <img
                          src="static/amp/blog/post-42/capa.png"
                          alt="Carro novo vermelho a frente e pessoas dando as mãos ao fundo"
                        />
                      </picture>
                      <div className="leilao-de-veiculos-blog-card-textos">
                        <h3 className="leilao-de-veiculos-blog-slide-titulo">
                          Carros novos ou usados: qual a melhor escolha para o seu bolso?
                        </h3>
                        <p className="leilao-de-veiculos-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            <h2 className="leilao-de-veiculos-blog-titulo">Consulte nossos conteúdos</h2>
            <div className="cards-desk">
              <a
                href="blog/leilao-de-veiculos-de-financeira.html"
                target="_blank"
                className="leilao-de-veiculos-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-11/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-11/capa.png" />
                  <img
                    src="static/amp/blog/post-11/capa.png"
                    alt="miniatura de um carro azul sobre moedas ao lado de um martelo de leilão"
                  />
                </picture>
                <div className="leilao-de-veiculos-blog-card-textos">
                  <h3 className="leilao-de-veiculos-blog-slide-titulo">
                    Leilão de carros recuperados de financeira: saiba como funciona
                  </h3>
                  <p className="leilao-de-veiculos-blog-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/comprar-carro-seminovo.html"
                target="_blank"
                className="leilao-de-veiculos-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-31/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-31/capa.jpg" />
                  <img
                    src="static/amp/blog/post-31/capa.jpg"
                    alt="homem olhando para um carro e pensando em comprar um carro seminovo"
                  />
                </picture>
                <div className="leilao-de-veiculos-blog-card-textos">
                  <h3 className="leilao-de-veiculos-blog-slide-titulo">
                    Comprar um carro seminovo é a melhor opção para o seu bolso?
                  </h3>
                  <p className="leilao-de-veiculos-blog-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/carros-novos-ou-usados.html"
                target="_blank"
                className="leilao-de-veiculos-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-42/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-42/capa.png" />
                  <img
                    src="static/amp/blog/post-42/capa.png"
                    alt="Carro novo vermelho a frente e pessoas dando as mãos ao fundo"
                  />
                </picture>
                <div className="leilao-de-veiculos-blog-card-textos">
                  <h3 className="leilao-de-veiculos-blog-slide-titulo">
                    Carros novos ou usados: qual a melhor escolha para o seu bolso?
                  </h3>
                  <p className="leilao-de-veiculos-blog-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default LeilaoDeVeiculosBlog;
